import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, delay = 0, inView = false, className = "", lineClassName = "" }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.13, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "115%" },
    show: { y: "0%", transition: { duration: 1.05, ease: EASE } },
  };
  return (
    <motion.div
      className={className}
      variants={container}
      initial="hidden"
      {...(inView
        ? { whileInView: "show", viewport: { once: true, margin: "-40px" } }
        : { animate: "show" })}
    >
      {lines.map((content, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span variants={line} className={`block ${lineClassName}`}>
            {content}
          </motion.span>
        </span>
      ))}
    </motion.div>
  );
};
